import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/finally';
import { NotificationsService } from 'angular2-notifications';

import { Tracker, Position } from '../../../entities/index';
import { TrackerService } from '../../../services/tracker.service';
import { Log } from '../../../utils/index';

@Component({
  selector: 'app-tracker-position',
  templateUrl: './tracker-position.html'
})
export class TrackerPositionComponent {
  _tracker: Tracker;
  lastPosition: Position;
  test = true;

  constructor(protected router: Router,
              protected trackerService: TrackerService,
              protected notificationService: NotificationsService) {
  }

  @Input()
  set tracker(tracker: Tracker) {
    this.lastPosition = (tracker && tracker.position && tracker.position.length > 0) ? tracker.position[0] : null;
    this._tracker = tracker;
  }

  get tracker() {
    return this._tracker;
  }

  @Log('blue')
  sendReset() {
    if (confirm('Are you sure you want to send a RESET!1 (restart) command')) {
      this.trackerService.reset(this._tracker.id).subscribe(
        return_value => this.notificationService.success('SUCCESS', 'RESET command sent'),
        return_value => this.notificationService.error('ERROR', 'Error while sending the reset command')
      );
    }
  }

  @Log('blue')
  sendResetFactory() {
    if (confirm('Are you sure you want to send a RESET! (reset factory) command')) {
      this.trackerService.resetFactory(this._tracker.id).subscribe(
        return_value => this.notificationService.success('SUCCESS', 'RESET command sent'),
        return_value => this.notificationService.error('ERROR', 'Error while sending the reset command')
      );
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/blocks/tracker-position/tracker-position.component.ts